import React, { useMemo } from "react";
import Chart from "react-apexcharts";

const ChartArea = ({ 
   
    data
}) => {
    
    const  options = {
        xaxis: {
            categories: ["PRICE"]
        },
        colors:[
            '#0445fb',
            '#d7dd03',
            '#2cd732',
            '#C70039'
        ]
    }

    const series = useMemo(()=>{

        return  [
            {
                name: "REAL",
                data: [data.oldData.toFixed(4)]
            },
            {
                name: "AVERAGE",
                data: [data.newData.toFixed(4)]
                
            },
            {
                name: "MAX",
                data: [data.maxPrice.toFixed(4)]
            },
           
            {
                name: "MIN",
                data: [data.minPrice.toFixed(4)]
            },
         
        ]
    },[data])

    return <Chart
        options={options}
        series={series}
        type="area"
        width="500"
    />


}

export default ChartArea